import { render } from "./ParallaxObject.vue?vue&type=template&id=ddf50c56&scoped=true&ts=true"
import script from "./ParallaxObject.vue?vue&type=script&lang=ts"
export * from "./ParallaxObject.vue?vue&type=script&lang=ts"

import "./ParallaxObject.vue?vue&type=style&index=0&id=ddf50c56&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddf50c56"]])

export default __exports__